export const UPLOAD_VIEW_TRANSITION_MS = 150;
